import React, { forwardRef } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

/**
 * This HOC is written to Wrap the component with Error boundary
 * @param {ReactComponent} Component
 */

function ErrorFallback({ error, resetErrorBoundary }) {
  return <div>Error...</div>;
}

function withErrorBoundary(Component) {
  class Wrapper extends React.Component {
    render() {
      const { innerRef, ...props } = this.props;
      return <Component ref={innerRef} {...props} />;
    }
  }
  const HOCWrapper = Wrapper;
  return forwardRef((props, ref) => (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <HOCWrapper {...props} innerRef={ref} />
    </ErrorBoundary>
  ));
}

export default withErrorBoundary;
